import React from 'react'
import * as icons from 'assets/icons'
import { SVG } from 'components'

export default ({ icon, fill, ...props }) => (
  <SVG src={icons?.[icon]} fill={fill} {...props} />
)
